export * from './mypreference.component';
